import type { ChannelType } from "@shared/api";

/**
 * Канал сервера с лентой сообщений: текстовый или объявлений. Объявления —
 * тот же текстовый канал, только опубликованное в нём расходится подписчикам.
 */
export function isFeed(type: ChannelType): boolean {
  return type === "text" || type === "announcement";
}

/**
 * Канал сервера со звонком: голосовой или сцена. Сцена — тот же голосовой
 * канал, только говорят на ней выступающие, а остальные слушают.
 */
export function isCall(type: ChannelType): boolean {
  return type === "voice" || type === "stage";
}
